import service from "./request";

/**   EG
 * 封装get post 的 两种方式
 * @param params 传入的阐述
 * @param path 为路径
 * @returns {Promise}
 */
// get
export const $getSendCode = (params = {}) => {
  return service.post("/path", params);
};
// post
export const $postSendCode = (params = {}) => {
  return service.post("/path", {
    params,
  });
};

// 获取轮播图
export const $getBannerHome = (params = {}) => {
  return service.get("/home/banner_list", { params });
};

// 获取轮播图
export const $getBanner = (params = {}) => {
  return service.get("/home/banner_list", { params });
};

// 获取底部信息
export const $getLogoContentr = (params = {}) => {
  return service.get("/home/logo_content", { params });
};
// 服务快捷入口
export const $get_photo = (params = {}) => {
  return service.get("/home/get_photo", { params });
};
// 账号密码登录
export const $login = (params = {}) => {
  return service.post("/user/login", params);
};
// 验证码登录
export const $mobilelogin = (params = {}) => {
  return service.post("/user/mobilelogin", params);
};
// 发送验证码
export const $send_code = (params = {}) => {
  return service.post("/user/send_code", params);
};
// 获取场景和模式接口
export const $get_scene = (params = {}) => {
  return service.get("/home/get_scene", { params });
};
// 获取智能照明素材接口
export const $get_material = (params = {}) => {
  return service.get("/home/get_material", { params });
};
// 忘记密码
export const $resetpwd = (params = {}) => {
  return service.post("/user/resetpwd", params);
};
// 关于我们
export const $aboutOut = (params = {}) => {
  return service.get("/my/get_contents", { params });
};
// 常见疑问接口
export const $getProblem = (params = {}) => {
  return service.get("/my/get_problem", { params });
};
// 获取通知公告接口
export const $getNotice = (params = {}) => {
  return service.get("/my/get_notice", { params });
};
// 查看详情接口
export const $getDetail = (params = {}) => {
  return service.get("/my/get_detail", { params });
};
// 我的课程
export const $getmyCourse = (params = {}) => {
  return service.post("/my_course/list", params);
};
// 我的发票信息
export const $getBill = (params = {}) => {
  return service.get("/material/Bill", { params });
};

// 提交我的发票信息
export const $bill_submit = (params = {}) => {
  return service.post("/material/bill_submit", params);
};

// 培训预告
export const $trainingNotice = (params = {}) => {
  return service.get("/course/training_notice", { params });
};

// 往期回顾列表
export const $courseList = (params = {}) => {
  return service.get("/course/course_list", { params });
};
// 西顿云设计
export const $createCase = (params = {}) => {
  return service.get("/cloud_design/create_case", { params });
};

/**
 * 封装post 上传formaData数据
 * @param url  
 * @param formData  file参数记得使用 const formData = new FormData();
        formData.append("file", file);
 * @returns {Promise}
 */
export const $uploadFormData = ({ formData, onUploadProgress = () => { } }) => {
  const config = {
    headers: {
      ...service.defaults.headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  };
  return service.post(`/upload/upload`, formData, config);
};
/**
 * 封装post 上传formaData数据
 * @param url  
 * @param formData  file参数记得使用 const formData = new FormData();
        formData.append("file", file);
 * @returns {Promise}
 */
export const $uploadUploadLarge = ({
  formData,
  onUploadProgress = () => { },
}) => {
  const config = {
    headers: {
      ...service.defaults.headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  };
  return service.post(`/upload/upload_large`, formData, config);
};
/**
 * 封装post 上传formaData数据
 * 断点续传 分片上传
 * @param url  
 * @param formData  file参数记得使用 const formData = new FormData();
        formData.append("file", file);
 * @returns {Promise}
 */
export const $uploadOnlySplitUpload = ({
  formData,
  onUploadProgress = () => { },
}) => {
  const config = {
    headers: {
      ...service.defaults.headers,
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  };
  return service.post(`/upload/only_split_upload`, formData, config);
};
/**
 * 封装post 上传formaData数据
 * 获取分片上传唯一标识符
 * @param url
 * @returns {Promise}
 */

export const $uploadOnlySplitOn = (params = {}) => {
  return service.get("/upload/only_split_on", { params });
};
/** */

//mei start

// post
export const $postStudentLogin = (params = {}) => {
  return service.post("student/student_login", {
    params,
  });
};
//智能照明列表
export const $smartProduct = (params = {}) => {
  return service.get("/product/smart_product", { params });
};
//设计素材下载
export const $materialDownload = (params = {}) => {
  return service.get("/product/material_download", { params });
};
//设计案例分享
export const $designShare = (params = {}) => {
  return service.get("/product/design_share", { params });
};

//设计案例分享-详情
export const $designShareDetails = (params = {}) => {
  return service.post("/product/design_share_details", params);
};

//智能照明更多列表-列表
export const $comboList = (params = {}) => {
  return service.post("/product/combo_list", params);
};
//智能照明更多列表-详情
export const $comboListDetails = (params = {}) => {
  return service.post("/product/combo_list_details", params);
};

/* 订单管理 */
// 订单列表操作
/** */

//智能照明更多列表-详情
export const $orderList = (params = {}) => {
  return service.post("/order/list", params);
};

//设计师列表
export const $orderDesignList = (params = {}) => {
  return service.get("/order/design_list", { params });
};

//分配设计师
export const $allocationDesign = (params = {}) => {
  return service.post("/order/allocation_design", params);
};

//订单取消
export const $cancelOrder = (params = {}) => {
  return service.post("/order/cancel_order", params);
};

//拒绝分配(主设计师)
export const $refusedAllocation = (params = {}) => {
  return service.post("/order/refused_allocation", params);
};

//同意分配
export const $agreeAllocation = (params = {}) => {
  return service.post("/order/agree_allocation", params);
};

//分配协助设计师
export const $allocationChildDesig = (params = {}) => {
  return service.post("/order/allocation_child_design", params);
};

//协助设计师,拒绝分配
export const $childRefusedAllocation = (params = {}) => {
  return service.post("/order/child_refused_allocation", params);
};

//协助设计师,同意分配
export const $childAgreeAllocation = (params = {}) => {
  return service.post("/order/child_agree_allocation", params);
};

//方案评价
export const $palnEvaluate = (params = {}) => {
  return service.post("/order/paln_evaluate", params);
};

//方案列表
export const $planList = (params = {}) => {
  return service.get("/order/plan_list", { params });
};

//上传方案
export const $uploadPlan = (params = {}) => {
  return service.post("/order/upload_plan", params);
};

//删除方案
export const $delPlan = (params = {}) => {
  return service.post("/order/del_plan", params);
};

//订单报价
export const $reportPrice = (params = {}) => {
  return service.get("/order/report_price", { params });
};

//确定报价
export const $quotedPrice = (params = {}) => {
  return service.post("/order/quoted_price", params);
};

//方案审核
export const $palnAudit = (params = {}) => {
  return service.post("/order/paln_audit", params);
};

//方案验收
export const $palnAcceptance = (params = {}) => {
  return service.post("/order/paln_acceptance", params);
};

//修改方案
export const $planEdit = (params = {}) => {
  return service.post("/order/paln_edit", params);
};

//申请协助
export const $requestAssist = (params = {}) => {
  return service.post("/order/request_assist", params);
};

//方案验收
export const $firmPrice = (params = {}) => {
  return service.post("/order/firm_price", params);
};

//支付信息
export const $orderPayInfo = (params = {}) => {
  return service.post("/order/order_pay_info", params);
};

//支付信息
export const $payQrCode = (params = {}) => {
  return service.post("/order/pay_qr_code", params);
};

//方案提交
export const $palnSubmit = (params = {}) => {
  return service.get("/order/paln_submit", { params });
};

// 上级领导审批接口
export const $leadAuth = (params = {}) => {
  return service.post("/order/lead_audit", params);
};

//轮询支付结果
export const $queryPay = (params = {}) => {
  return service.get("/order/query_pay", { params });
};

//申请售后 撤单
export const $afterSales = (params = {}) => {
  return service.post("/order/after_sales", params);
};

//撤单申请被拒绝_确定操作
export const $refundRefusedConfirm = (params = {}) => {
  return service.post("/order/refund_refused_confirm", params);
};

//用户协议和隐私政策接口
export const $agreement = (params = {}) => {
  return service.get("/user/agreement", { params });
};

//mei end

/* LE */
/* 技术服务 业态分类 */
export const $place_orderBusiness_type = (params = {}) => {
  return service.get("/place_order/business_type", { params });
};
/* 技术服务 获取关联项目和指定产品 */
export const $placeOrderRelation_project = (params = {}) => {
  return service.get("/place_order/relation_project", { params });
};
/* 技术服务 方案服务 */
export const $place_orderPlan_service = (params = {}) => {
  return service.get("/place_order/plan_service", { params });
};
/* 技术服务 外出需求 */
export const $place_orderOut_service = (params = {}) => {
  return service.get("/place_order/out_service", { params });
};
/* 技术服务 /place_order/page */
export const $placeOrderPage = (params = {}) => {
  return service.get("/place_order/page", { params });
};

/* 技术服务 计算价格 */
export const $place_orderCalculatePrice = (params = {}) => {
  return service.post("/place_order/calculate_price", params);
};
/* 权限节点 */
export const $authRoleList = (params = {}) => {
  return service.get("/user_auth/auth_role_list", { params });
};

/* 云设计方案列表 */
export const $cloud_designList = (params = {}) => {
  return service.get("/cloud_design/list", { params });
};

/* 云设计方案我要设计*/
export const $cloudDesignCreateCase = (params = {}) => {
  return service.get("/cloud_design/create_case", { params });
};

/* 云设计方案编辑方案*/
export const $cloudDesignEditCase = (params = {}) => {
  return service.post("/cloud_design/edit_case", params);
};

/* 云设计方案复制方案*/
export const $cloudDesignCopyCase = (params = {}) => {
  return service.post("/cloud_design/copy_case", params);
};

/* 云设计方案删除方案*/
export const $cloudDesignRmCase = (params = {}) => {
  return service.post("/cloud_design/rm_case", params);
};
// 云设计分类列表
export const $cloudDesignCaseList = (params = {}) => {
  return service.get("/cloud_design/case_list", { params });
};
// 添加云设计分类
export const $cloudDesignCaseType = (params = {}) => {
  return service.post("/cloud_design/create_case_type", params);
};
// 重命名云设计分类
export const $cloudDesignEdit = (params = {}) => {
  return service.post("/cloud_design/edit_case_type", params);
};
// 删除云设计分类
export const $cloudDesignDelCaseType = (params = {}) => {
  return service.post("/cloud_design/del_case_type", params);
};
// 将户型方案关联到分类
export const $cloudDesigncaseAddCaseType = (params = {}) => {
  return service.post("/cloud_design/case_add_case_type", params);
};
/* 日报管理-我的日报列表*/
export const $dailyUserDailyList = (params = {}) => {
  return service.post("/daily/user_daily_lists", params);
};

/* 日报管理-我的日报列表-用户筛选列表*/
export const $dailyUserNameList = (params = {}) => {
  return service.post("/daily/user_name_list", params);
};

/* 日报管理-我的日报列表-添加日报*/
export const $dailyUserDailyAdd = (params = {}) => {
  return service.post("/daily/user_daily_add", params);
};

/* 添加日报-选择 人员&订单 列表*/
export const $dailyUserList = (params = {}) => {
  return service.post("/daily/user_list", params);
};

/* 日报管理-我的日报列表-详情*/
export const $dailyUserDailyDetail = (params = {}) => {
  return service.post("/daily/user_daily_detail", params);
};

/* 日报管理-我的日报列表-编辑日报*/
export const $dailyUserDailyEdit = (params = {}) => {
  return service.post("/daily/user_daily_edit", params);
};

/* 订单管理-订单详情*/
export const $orderOrderDetail = (params = {}) => {
  return service.post("/order/order_detail", params);
};

/* 技术服务-课程详情*/
export const $courseCourseRegisterInfo = (params = {}) => {
  return service.post("/course/course_register_info", params);
};

/* 技术服务-课程详情 提交*/
export const $courseCourseRegister = (params = {}) => {
  return service.post("/course/course_register", params);
};

/* 技术服务-课程详情 往期回顾详情*/
export const $courseCourseDetails = (params = {}) => {
  return service.post("/course/course_details", params);
};

/* 技术服务-课程详情 往期回顾详情*/
export const $placeOrderPaper = (params = {}) => {
  return service.get("/place_order/paper", { params });
};

/*添加平台访问量*/
export const $systemAccessPlatform = (params = {}) => {
  return service.get("/system/access_platform", { params });
};

/*判断支付类型*/
export const $orderIsPayType = (params = {}) => {
  return service.post("/order/is_pay_type", params);
};

/*余额支付*/
export const $orderPayBalance = (params = {}) => {
  return service.post("/order/pay_balance", params);
};

/*添加日报-选择订单-列表*/
export const $dailyAssociateOrder = (params = {}) => {
  return service.post("/daily/associate_order", params);
};

/*添加日报-选择人员-列表*/
export const $dailyAssociateUser = (params = {}) => {
  return service.post("/daily/associate_user", params);
};

/*校验验证码*/
export const $userCheckCode = (params = {}) => {
  return service.post("/user/check_code", params);
};

/*获取标题*/
export const $indexTitle = (params = {}) => {
  return service.get("/api/index/title", { params });
};

/*设计素材下载-下载/播放计数*/
export const $productDownloadCount = (params = {}) => {
  return service.post("/product/download_count", params);
};

/*是否需要显示操作指引*/
export const $userAuthShowGuide = (params = {}) => {
  return service.get("/user_auth/show_guide", { params });
};

/*订单补充说明-获取*/
export const $get_order_mi = (params = {}) => {
  return service.get("/order/get_order_mi", { params });
};

/*订单补充说明-修改*/
export const $get_order_mi_add = (params = {}) => {
  return service.post("/order/order_mi_add", params);
};

/*订单导出*/
export const $pullOrderExport = (params = {}) => {
  return service.post("/order/order_export", params);
};

/*CRM项目列表*/
export const $crmPlaceOrder = (params = {}) => {
  return service.get("/crm_design/project_list", { params });
};

/*CRM下单授权登录*/
export const $crmPlaceGetCrmOrder = (params = {}) => {
  return service.post("/crm_place/getcrmorder", params);
};

/** HUI */
// 消息通知
/* 消息通知-消息列表 */
export const $infoList = (params = {}) => {
  return service.post("/info/info_list", params);
};

/* 消息通知-最新消息 */
export const $infoNew = (params = {}) => {
  return service.post("/info/info_new", params);
};

/* 消息通知-消息详情 */
export const $infoDetails = (params = {}) => {
  return service.post("/info/info_details", params);
};

/* 消息通知-一键已读 */
export const $infoRead = (params = {}) => {
  return service.post("/info/read", params);
};

// 财政管理
/* 财务管理-发票管理列表 */
export const $billList = (params = {}) => {
  return service.get("/finance/bill_list", { params });
};

/* 财务管理-发票详情 */
export const $billDetails = (params = {}) => {
  return service.post("/finance/bill_details", params);
};

/* 财务管理-下载发票 */
export const $downloadInvoice = (params = {}) => {
  return service.post("/finance/download_invoice", params);
};

/* 财务管理-支付流水列表 */
export const $paymentFlowLis = (params = {}) => {
  return service.get("/finance/payment_flow_list", { params });
};

/* 财务管理-支付流水-申请发票-内容 */
export const $applyInvoicing = (params = {}) => {
  return service.post("/finance/apply_invoicing", params);
};

/* 财务管理-支付流水-提交开票 */
export const $invoiceSubmit = (params = {}) => {
  return service.post("/finance/invoice_submit", params);
};

/* 技术服务-保存草稿 */
export const $placeOrderDraft = (params = {}) => {
  return service.post("/place_order/draft", params);
};

/* 技术服务-确认下单 */
export const $placeOrderAdd = (params = {}) => {
  return service.post("/place_order/add", params);
};

/* 技术服务-订单编辑 */
export const $placeOrderEdit = (params = {}) => {
  return service.post("/place_order/edit", params);
};

/* 文件上传 */
// export const $uploadData = (params = {}) => {
//   return service.post("/upload/upload", params);
// };

// 我的资料
/* 我的资料-个人信息-修改个人信息接口 */
export const $userProfile = (params = {}) => {
  return service.post("/user/profile", params);
};

/* 我的资料-个人信息-获取个人信息接口 */
export const $userDetail = (params = {}) => {
  return service.get("/user/user_detail", { params });
};

/* 我的资料-修改密码-修改密码接口 */
export const $modifypwd = (params = {}) => {
  return service.post("/user/modifypwd", params);
};

// 仪表盘
/* 仪表盘-所接订单统计 */
export const $panelOrderCount = (params = {}) => {
  return service.get("/panel/order_count", { params });
};

/* 仪表盘-区域订单统计 */
export const $panelAreaOrder = (params = {}) => {
  return service.get("/panel/area_order", { params });
};

/* 仪表盘-订单统计 */
export const $panelOrderChart = (params = {}) => {
  return service.get("/panel/order_chart", { params });
};

/* 仪表盘-订单时效 */
export const $orderAging = (params = {}) => {
  return service.get("/panel/my_order_timeliness", { params });
};

/* 仪表盘-订单来源 */
export const $orderSource = (params = {}) => {
  return service.get("/panel/order_source", { params });
};

/* 仪表盘-员工当月排行榜 */
export const $staffList = (params = {}) => {
  return service.get("/panel/staff_rank_by_month", { params });
};

/* 仪表盘-平均订单时效 */
export const $orderAvgTimeliness = (params = {}) => {
  return service.get("/panel/order_avg_timeliness", { params });
};

/* 仪表盘-最快处理时效 */
export const $orderFastestTimeliness = (params = {}) => {
  return service.get("/panel/order_fastest_timeliness", { params });
};

/* 仪表盘-最慢处理时效 */
export const $orderSlowestTimeliness = (params = {}) => {
  return service.get("/panel/order_slowest_timeliness", { params });
};

// 关于我们
/* 关于我们-核心团队接口 */
export const $myGstTitle = (params = {}) => {
  return service.get("/my/get_title", { params });
};

/* 关于我们-服务内容接口 */
export const $myGstContent = (params = {}) => {
  return service.get("/my/get_content", { params });
};

/* 关于我们-服务流程接口 */
export const $myGstBottom = (params = {}) => {
  return service.get("/my/get_bottom", { params });
};

/* 关于我们-帮助中心-标记为已读 */
export const $mySignRead = (params = {}) => {
  return service.get("/my/sign_read", { params });
};

/* 关于我们-搜索接口 */
export const $getSearch = (params = {}) => {
  return service.get("/my/get_search", { params });
};

/* 关于我们-获取搜索类型 */
export const $getSearchType = (params = {}) => {
  return service.get("/my/get_search_type", { params });
};

//
/* 设计案例分享-分享二维码 */
export const $getQeCode = (params = {}) => {
  return service.get("/product/design_share_details_qe_code", { params });
};

//
/* 智能照明-顶部图片 */
export const $productImage = (params = {}) => {
  return service.get("/product/image", { params });
};

// 下单
/* 下单 - 获取关联项目和指定产品(编辑页) */
export const $relationProjectEdit = (params = {}) => {
  return service.post("/place_order/relation_project_edit", params);
};

// 日报管理
/* 日报管理 - 获取删除后的相关人员 */
export const $associateUserEdit = (params = {}) => {
  return service.post("/daily/associate_user_edit", params);
};

// 友情链接列表
export const $blogroll_link = () => {
  return service.get('/links')
}